/*
 * The product offer selector.
 *
 * Two jobs, both read-only with respect to the cart:
 *
 * 1. Keeps the prices shown inside the selector in sync with the contextual
 *    price Shopify renders for the currently selected variant. It only mirrors
 *    markup Shopify already rendered (the same section HTML `product-info.js`
 *    uses for the native price row), so money formatting, Markets and currency
 *    settings stay entirely server-side.
 *
 * 2. Exposes the selected offer and the server-verified gift data so
 *    `product-form.js` can build a bundle add. The checked radio remains the
 *    single source of truth - no shadow state is kept here, and this component
 *    performs no cart writes of its own.
 */
if (!customElements.get('offer-selector')) {
  customElements.define(
    'offer-selector',
    class OfferSelector extends HTMLElement {
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.sectionId) return;
          this.updatePrices(event.data.html);
        });
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      /* The checked radio is authoritative. Defaults to the non-bundle offer so a
       * missing or unchecked selector can never add an unintended gift. */
      get selectedOffer() {
        const checked = this.querySelector('.offer-option__input:checked');
        return (checked && checked.dataset.offerKey) || 'single';
      }

      /* Server-rendered from the explicit gift product picker only. */
      get giftVariantId() {
        return this.dataset.giftVariantId || null;
      }

      get parentProductId() {
        return this.dataset.parentProductId || null;
      }

      get giftReady() {
        return (
          this.dataset.giftConfigured === 'true' &&
          this.dataset.giftAvailable === 'true' &&
          Boolean(this.giftVariantId)
        );
      }

      get giftErrorMessage() {
        return this.dataset.giftError || '';
      }

      updatePrices(html) {
        if (!html) return;

        this.querySelectorAll('[data-offer-price-id]').forEach((destination) => {
          const source = html.getElementById(`${destination.dataset.offerPriceId}-${this.dataset.sectionId}`);
          if (source) destination.innerHTML = source.innerHTML;
        });
      }
    }
  );
}
